import { ModalHeaderComponentModule } from 'src/app/app/_component/modal-header/modal-header.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { UserAssignmentViewDetailsComponent } from "./user-assignment-view-details.component";
import { TranslateModule } from "@ngx-translate/core";
import { ImagePreviewModule } from "src/app/app/_component/image-preview/image-preview.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ImagePreviewModule,
    ModalHeaderComponentModule
  ],
  declarations: [UserAssignmentViewDetailsComponent],
  exports: [UserAssignmentViewDetailsComponent],
})
export class UserAssignmentViewDetailsComponentModule {}
